import api from '../../api.js';

export const TABS_SELECTOR = api.core.ns.selector('tabs');
export const TABS_CLASS = api.core.ns('tabs');
export const TAB_CLASS = api.core.ns('tabs__tab');
export const PANEL_CLASS = api.core.ns('tabs__panel');
export const LIST_CLASS = api.core.ns('tabs__list');

export const TRANSITION_TIME = 100;
